import React, { Suspense } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { installErrorReporter } from 'shared/services/errorReporter';
import { ADMIN_ROUTES } from './router/adminRoutes';
import { EXPERT_ROUTES } from './router/expertRoutes';
import { MANAGER_ROUTES } from './router/managerRoutes';
import { OPERATIONS_ROUTES } from './router/operationsRoutes';
import { PUBLIC_ROUTES } from './router/publicRoutes';
import { AppRoute } from './router/types';
import { AppProviders } from './providers';

installErrorReporter();

export const APP_ROUTES: AppRoute[] = [
  ...PUBLIC_ROUTES,
  ...EXPERT_ROUTES,
  ...MANAGER_ROUTES,
  ...OPERATIONS_ROUTES,
  ...ADMIN_ROUTES,
];

function RouteFallback() {
  return <div className="min-h-screen bg-slate-50" />;
}

function AppRouter() {
  return <Suspense fallback={<RouteFallback />}>{useRoutes(APP_ROUTES as RouteObject[])}</Suspense>;
}

function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AppProviders>
  );
}

export default App;
